import { TextField } from '@mui/material';

interface VllmEndpointFieldProps {
  value: string;
  error?: string;
  setValue: (value: string) => void;
}

function VllmEndpointField({
  value,
  error,
  setValue,
}: VllmEndpointFieldProps): React.JSX.Element {
  return (
    <TextField
      fullWidth
      label='vLLM Endpoint'
      value={value}
      error={Boolean(error)}
      helperText={error}
      onChange={(e) => setValue(e.target.value)}
    />
  );
}

export default VllmEndpointField;

